import { render, staticRenderFns } from "./product-normal.vue?vue&type=template&id=cfadcaf2&scoped=true&"
import script from "./product-normal.vue?vue&type=script&lang=js&"
export * from "./product-normal.vue?vue&type=script&lang=js&"
import style0 from "./product-normal.vue?vue&type=style&index=0&id=cfadcaf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfadcaf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfadcaf2')) {
      api.createRecord('cfadcaf2', component.options)
    } else {
      api.reload('cfadcaf2', component.options)
    }
    module.hot.accept("./product-normal.vue?vue&type=template&id=cfadcaf2&scoped=true&", function () {
      api.rerender('cfadcaf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/product-normal.vue"
export default component.exports